import {
  useAccountReceivableArchiveList,
  useAccountReceivableArchiveRemove,
} from '@/core/domain/financial/AccountReceivable/AccountReceivable.hooks';
import { AccountReceivableArchive } from '@/core/domain/financial/AccountReceivable/AccountReceivable.types';
import { Modal, Table } from 'antd';
import { ColumnsType } from 'antd/lib/table';
import { DeleteIcon } from '@/components/_common';
import { useArchiveGetArchive } from '@/core/domain/archive/Archive/Archive.hooks';
import { useReportGenerate } from '@/hooks';
import { useBillToReceiveReleaseDetailContext } from '../ReleaseDetailProvider';

export default function BillToReceiveReleaseAttachmentList() {
  const { releaseId } = useBillToReceiveReleaseDetailContext();

  const archives = useAccountReceivableArchiveList(releaseId);
  const archiveRemove = useAccountReceivableArchiveRemove();
  const getArchive = useArchiveGetArchive();
  const report = useReportGenerate();

  function confirmRemove(item: AccountReceivableArchive) {
    Modal.confirm({
      title: 'Remoção de anexo',
      content: `Deseja remover o anexo "${item.fileName}"?`,
      onOk: () =>
        archiveRemove.mutateAsync({
          accountReceivableId: releaseId,
          fileId: item.id,
        }),
      okText: 'Remover',
      okType: 'danger',
    });
  }

  async function downloadAttachment(item: AccountReceivableArchive) {
    try {
      const paths = item.filePath.split('/');
      const key = paths.pop() as string;
      const subdirectory = paths.join('/').split('v1/Archive/')[1];

      const result = await getArchive.mutateAsync({ key, subdirectory });

      report.downloadFile({ fileName: item.fileName, result });
    } catch {}
  }

  const columns: ColumnsType<AccountReceivableArchive> = [
    {
      title: 'Arquivo',
      dataIndex: 'fileName',
      width: 200,
      render: (_, item) => (
        <a
          style={{ fontWeight: 'bold' }}
          onClick={async (e) => {
            e.preventDefault();
            downloadAttachment(item);
          }}
        >
          {item.fileName}
        </a>
      ),
    },
    {
      title: 'Ação',
      align: 'right',
      width: 100,
      render: (item) => (
        <>
          <DeleteIcon onClick={() => confirmRemove(item)} />
        </>
      ),
    },
  ];

  return (
    <Table
      loading={archives.isLoading}
      dataSource={archives.data}
      columns={columns}
      pagination={false}
      scroll={{ x: true }}
    />
  );
}
